import CommentObjectType from './CommentObjectType';
import { FLOATING_SIDEBAR_TOUR_ID } from './tourIDs';
const floatingSidebarTourBlockList = [CommentObjectType.REPORTING_DASHBOARD, CommentObjectType.WORKFLOW, CommentObjectType.MARKETING_EMAIL];
const onboardingTourBlockListedObjectTypes = {
  [FLOATING_SIDEBAR_TOUR_ID]: floatingSidebarTourBlockList
};
export default onboardingTourBlockListedObjectTypes;